module.exports = __webpack_public_path__ + "static/content1-img-54a84dfc463bf7e537a2720b76eb3cb8.png";